/**
 *
 * ButtonBar
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import cn from 'classnames';

export function ButtonBar(props) {
  return <div className={cn("buttonbar", props.className)}>{props.children}</div>;
}
